(() => {
  if (window.__icuCartDrawerRefreshInstalled) return;
  window.__icuCartDrawerRefreshInstalled = true;

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const url =
      typeof args[0] === 'string'
        ? args[0]
        : args[0]?.url || '';

    const isICUCartAdd =
      url.includes('/cart/add.js') &&
      url.includes('icu=1');

    const response = await originalFetch.apply(this, args);

    if (isICUCartAdd && response.ok) {
      document.dispatchEvent(
        new CustomEvent('dispatch:cart-drawer:refresh')
      );
    }

    return response;
  };
})();